import { api } from "@/context/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const ITEMS = [
  { key: "alle_arbeiten_abgeschlossen", label: "Alle Arbeiten abgeschlossen" },
  { key: "probefahrt_durchgefuehrt", label: "Probefahrt durchgeführt" },
  { key: "funktionspruefung_elektrisch", label: "Elektrische Funktionsprüfung" },
];

export const AbschlusskontrolleCard = ({ order, onOrderUpdate }) => {
  if (!order?.arbeitskarte) return null;

  const handleChange = async (key, checked) => {
    try {
      await api.put(`/api/work-orders/${order.id}/arbeitskarte/abschlusskontrolle`, { [key]: checked });
      const updated = {
        ...order,
        arbeitskarte: {
          ...order.arbeitskarte,
          abschlusskontrolle: { ...order.arbeitskarte.abschlusskontrolle, [key]: checked }
        }
      };
      onOrderUpdate?.(updated);
    } catch {
      toast.error("Fehler beim Aktualisieren");
    }
  };

  return (
    <Card data-testid="detail-abschluss-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-primary" />Abschlusskontrolle
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {ITEMS.map(item => (
          <div key={item.key} className="flex items-center gap-3">
            <Checkbox
              checked={order.arbeitskarte.abschlusskontrolle?.[item.key] || false}
              onCheckedChange={(checked) => handleChange(item.key, checked)}
              data-testid={`detail-ak-${item.key}`}
            />
            <span className="text-sm">{item.label}</span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
